<div class="password-strength-container">
  <div class="password-strength-item" [class.valid]="hasMinimumLength">
    <i
      class="fa"
      [class.fa-check-circle]="hasMinimumLength"
      [class.fa-circle]="!hasMinimumLength"
    ></i>
    <span translate>Minimum 8 characters</span>
  </div>
  <div class="password-strength-item" [class.valid]="hasLowerCase">
    <i
      class="fa"
      [class.fa-check-circle]="hasLowerCase"
      [class.fa-circle]="!hasLowerCase"
    ></i>
    <span translate>At least one lowercase letter</span>
  </div>
  <div class="password-strength-item" [class.valid]="hasUpperCase">
    <i
      class="fa"
      [class.fa-check-circle]="hasUpperCase"
      [class.fa-circle]="!hasUpperCase"
    ></i>
    <span translate>At least one uppercase letter</span>
  </div>
  <div class="password-strength-item" [class.valid]="hasDigit">
    <i
      class="fa"
      [class.fa-check-circle]="hasDigit"
      [class.fa-circle]="!hasDigit"
    ></i>
    <span translate>At least one digit</span>
  </div>
  <div class="password-strength-item" [class.valid]="hasSpecialChar">
    <i
      class="fa"
      [class.fa-check-circle]="hasSpecialChar"
      [class.fa-circle]="!hasSpecialChar"
    ></i>
    <span translate>At least one special character</span>
  </div>
</div>
